// extracted by mini-css-extract-plugin
export default {"imageWrapper":"sL-z","twoColumnImage":"tL-z"};